import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import appConstant from '../../constants';
import ah from '../../helpers/Axhelper';
import * as actions from "./actions";

let defLimit = 50;
let defSortColumn = 'created';
let defSortDirection = 'desc';

let urlAll = appConstant.baseUrl+"expenses/all/";
let urlDetails = appConstant.baseUrl+"expenses/details/";
let urlSearch = appConstant.baseUrl+"expenses/search/"; 
let urlDelete = appConstant.baseUrl+"expenses/";
let urlInsert = appConstant.baseUrl+"expenses/";
let urlUpdate = appConstant.baseUrl+"expenses/";

const computeListUrl = (searchField, sortColumn, sortDirection, limit) => {
    //console.log("computeListUrl -> searchField, sortColumn, sortDirection, limit", searchField, sortColumn, sortDirection, limit);
    let computedSort = sortColumn || defSortColumn;
    let computedDirection = sortDirection || defSortDirection;
    let computedLimit = limit || defLimit; 
    let computedSearchUrl = urlSearch.concat(encodeURIComponent(searchField)).concat(`?sortcol=${computedSort}&sortdir=${computedDirection}&limit=${computedLimit}`);
    let computedAllUrl = urlAll.concat(`?sortcol=${computedSort}&sortdir=${computedDirection}&limit=${computedLimit}`);

    if(!searchField || searchField.length===0) { 
        return computedAllUrl 
    } else { 
        return computedSearchUrl 
    }
}

function* getItems(actionObject) {
    let {searchField, sortColumn, sortDirection, limit} = actionObject.payload;
    let currentUrl = computeListUrl(searchField, sortColumn, sortDirection, limit);
    const response = yield call(ah.sendGetAsync,currentUrl);
    if(response.error){
        yield put(actions.expensesGetError(response.error));
    } else {
        yield put(actions.expensesGetSuccess(response.data,response.headers["x-total-count"]));
    }
}

/* eslint require-yield: 0 */  
function* setSearch(actionObject) {
    if(actionObject.payload.length>=3){
        getItems(actionObject);
    }
}

function* loadMore(actionObject) {
    let {searchField, sortColumn, sortDirection, limit} = actionObject.payload;
    let currentUrl = computeListUrl(searchField, sortColumn, sortDirection, limit);
    const response = yield call(ah.sendGetAsync,currentUrl);
    if(response.error){
        yield put(actions.expensesLoadMoreError(response.error));
    } else {
        yield put(actions.expensesLoadMoreSuccess(response.data,response.headers["x-total-count"]));
    }
}

function* deleteItem(actionObject) {
    let id = actionObject.payload;
    let currentUrl = urlDelete.concat(id);
    const response = yield call(ah.sendDeleteAsync,currentUrl);
    if(response.error){
        yield put(actions.expensesDeleteItemError(response.error));
    } else {
        yield put(actions.expensesDeleteItemSuccess(response.data));
    }
}

function* getDetails(actionObject) {
    let id = actionObject.payload;
    let currentUrl = urlDetails.concat(id);
    const response = yield call(ah.sendGetAsync,currentUrl);
    if(response.error){
        yield put(actions.expensesGetDetailsError(response.error));
    } else {
        yield put(actions.expensesGetDetailsSuccess(response.data));
    }
}

function* insert(actionObject) {
    let item = actionObject.payload;
    const response = yield call(ah.sendPostAsync,urlInsert,item);
    if(response.error){
        yield put(actions.expensesInsertError(response.error));
    } else {
        yield put(actions.expensesInsertSuccess(response.data));
    }
}

function* loadUpdate(actionObject) {
    let id = actionObject.payload;
    let currentUrl = urlDetails.concat(id);
    const response = yield call(ah.sendGetAsync,currentUrl);
    if(response.error){
        yield put(actions.expensesLoadUpdateError(response.error));
    } else {
        yield put(actions.expensesLoadUpdateSuccess(response.data));
    }
}

function* update(actionObject) {
    console.log("function*update -> actionObject", actionObject);
    let id = actionObject.payload.id;
    let currentUrl = urlUpdate.concat(id);
    console.log("function*update -> currentUrl", currentUrl);
    const response = yield call(ah.sendPutAsync,currentUrl, actionObject.payload.item);
    if(response.error){
        yield put(actions.expensesUpdateError(response.error));
    } else {
        yield put(actions.expensesUpdateSuccess(response.data));
    }
}

export function* watchActions() {
    yield takeEvery('EXPENSES_GET', getItems);
    yield takeEvery('EXPENSES_SET_SEARCH_FIELD', setSearch);
    yield takeEvery('EXPENSES_LOAD_MORE', loadMore);
    yield takeEvery('EXPENSES_DELETE_ITEM', deleteItem);
    yield takeEvery('EXPENSES_GET_DETAILS', getDetails);
    yield takeEvery('EXPENSES_INSERT', insert);
    yield takeEvery('EXPENSES_LOAD_UPDATE', loadUpdate);
    yield takeEvery('EXPENSES_UPDATE', update);
}

export default function* rootSaga() {
    yield all([
        fork(watchActions)
    ]);
}